import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import Foso from '../../components/foso/Foso'
import {fetchFiltrarFoso, guardarFoso, modificarFoso, eliminarFoso, obtenerDatosVerraco, imprimirEtiquetaZebra} from '../../actions/foso/foso'
import {comboOperarioActivo, comboVerraco, comboUbicacion} from '../../actions/combos/combos'

export function mapStateToProps (state) {
  return {
    ...state.foso,
    numeroRegistrosPorPagina: state.common.numeroRegistrosPorPagina,
    paginaActual: state.common.paginaActual,
    auth: state.auth,
    combos: state.combos,
    formFoso: state.form.formFoso
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      fetchFiltrarFoso,
      comboOperarioActivo,
      comboUbicacion,
      guardarFoso,
      modificarFoso,
      eliminarFoso,
      comboVerraco,
      obtenerDatosVerraco,
      imprimirEtiquetaZebra
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Foso))